import styles from './SectionNum.module.css';

type Props = {
  number: number;
  label: string;
  theme?: 'light' | 'dark';
};

export default function SectionNum({ number, label, theme = 'light' }: Props) {
  return (
    <div className={`${styles.root} ${theme === 'dark' ? styles.dark : ''}`}>
      <span className={styles.circle}>{number}</span>
      <span className={styles.label}>{label}</span>
    </div>
  );
}
